// Vaanmathi
import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { sidebarMenuItems } from "../../../data/Menudata";
import idlbay from "../../../assets/idlbay.png";
import axios from "axios";

const Sidebar = ({ isOpen, onClose }) => {
  const location = useLocation();
  const navigate = useNavigate();
  // eslint-disable-next-line
  const [activeItem, setActiveItem] = useState("dashboard");
  const [expandedItems, setExpandedItems] = useState({});
  const [permissions, setPermissions] = useState({})

  const userId = sessionStorage.getItem("userId") || localStorage.getItem("userId");

  useEffect(() => {
    fetchPermissions();
  }, [])

  const fetchPermissions = async () => {
    try {
      const res = await axios.get(`https://api.dremerz.net/api/DZ_8922_Payroll_PayrollCreateAdmin_PayrollAdminList/${userId}`);
      setPermissions(res.data);
    } catch (error) {
      console.log("Error fetching permissions data : ", error);
    }
  }


  // Get active item from current location
  const getCurrentActiveItem = () => {
    const currentPath = location.pathname;

    // Check main items first
    const activeMenuItem = sidebarMenuItems.find(
      (item) => item.path === currentPath
    );
    if (activeMenuItem) {
      return activeMenuItem.id;
    }

    // Check child items
    for (const item of sidebarMenuItems) {
      if (item.children) {
        const activeChild = item.children.find(
          (child) => child.path === currentPath
        );
        if (activeChild) {
          return activeChild.id;
        }
      }
    }

    return "dashboard";
  };

  const getParentItem = (childId) => {
    for (const item of sidebarMenuItems) {
      if (item.children) {
        const child = item.children.find((c) => c.id === childId);
        if (child) {
          return item;
        }
      }
    }
    return null;
  };

const handleItemClick = (item) => {
  setActiveItem(item.id);

  // 🟢 If sidebar is collapsed and item has children → expand sidebar first
  if (!isOpen && item.hasSubmenu) {
    onClose(false); // keep open instead of closing
    return; // prevent immediate navigation so submenu shows
  }

  // 🟢 Handle submenu toggle (only one open at a time)
  if (item.hasSubmenu) {
    setExpandedItems((prev) => {
      if (prev[item.id]) {
        return {};
      }
      return { [item.id]: true };
    });
  }

  // 🟢 Navigate if path available
  if (item.path) {
    navigate(item.path);
  }

  // 🟢 Auto-close on mobile view
  if (window.innerWidth < 992 && item.path) {
    onClose();
  }
};



  const handleChildClick = (child, parent) => {
    setActiveItem(child.id);
    navigate(child.path);

    // Close sidebar on mobile after click
    if (window.innerWidth < 992) {
      onClose();
    }
  };

  // Get the current active item based on location
  const currentActiveItem = getCurrentActiveItem();

  // Auto-expand parent if child is active
  useEffect(() => {
    const parentItem = getParentItem(currentActiveItem);
    if (parentItem) {
      setExpandedItems((prev) => ({
        ...prev,
        [parentItem.id]: true,
      }));
    }
  }, [currentActiveItem]);

  return (
    <>
      {/* Backdrop for mobile - only show when sidebar is open */}
      {isOpen && window.innerWidth < 992 && (
        <div
          className="position-fixed start-0 w-100 h-100 d-lg-none"
          style={{ zIndex: 1056, backgroundColor: "#ffffffff" }}
          onClick={onClose}
        />
      )}

      {/* Sidebar */}
      <div
        className="position-fixed text-white d-flex flex-column"
        style={{
          width: isOpen ? "240px" : "70px",
          height: "100vh",
          top: "0",
          left: "0",
          zIndex: 1056,
          transition: "width 0.3s ease-in-out",
          backgroundColor: "#1e3147",
        }}
      >
        {/* Fixed Header Section */}
        <div
          className="border-bottom border-secondary"
          style={{ padding: "14px 0 10px 0", flexShrink: 0, marginTop: "-9px" }}
        >
          <div
            className="d-flex align-items-center justify-content-center"
            style={{ gap: "10px", height: "50px" }}
          >
            {isOpen ? (
              <h5
                className="text-white fw-bold"
                style={{ marginBottom: "-10px" }}
              >
                PAYROLL
              </h5>
            ) : (
              <div
                style={{
                  width: "40px",
                  height: "40px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "1.2rem",
                  fontWeight: "bold",
                  color: "white",
                }}
              >
                P
              </div>
            )}
          </div>
        </div>

        {/* Scrollable Menu Items */}
        <div
          className="flex-grow-1 overflow-auto sidebar-scroll mt-4"
          style={{
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            padding: "0 12px",
          }}
        >
          {/* Global style for hiding webkit scrollbar */}
          <style
            dangerouslySetInnerHTML={{
              __html: `
              .sidebar-scroll::-webkit-scrollbar {
                display: none;
              }
            `,
            }}
          />

          <nav className="nav flex-column">
            {sidebarMenuItems
              .filter(item => {
                // Always show item if it has children (we'll filter children separately)
                if (item.children) {
                  // Check if at least one child has permission
                  const hasPermittedChild = item.children.some(child =>
                    permissions?.permissions?.includes(child.id)
                  );
                  return hasPermittedChild;
                }
                // For items without children, check direct permission
                return permissions?.permissions?.includes(item.id);
              })
              .map((item) => {
                const IconComponent = item.icon;
                const isActive = currentActiveItem === item.id;
                const isExpanded = expandedItems[item.id];
                const hasActiveChild =
                  item.children &&
                  item.children.some((child) => child.id === currentActiveItem);

                // Filter children based on permissions
                const permittedChildren = item.children
                  ? item.children.filter(child =>
                    permissions?.permissions?.includes(child.id)
                  )
                  : [];

                return (
                  <div key={item.id} className="mb-1">
                    {/* Main Menu Item */}
                    <div
                      className={`btn text-start w-100 d-flex align-items-center ${isOpen
                          ? "justify-content-between"
                          : "justify-content-center"
                        } py-2 px-2 rounded text-decoration-none`}
                      onClick={() => handleItemClick(item)}
                      style={{
                        backgroundColor: "transparent",
                        border: "none",
                        color:
                          isActive || hasActiveChild
                            ? "white"
                            : "rgba(255,255,255,0.7)",
                        fontWeight: isActive || hasActiveChild ? "600" : "400",
                        cursor: "pointer",
                        transition: "all 0.2s ease",
                      }}
                      title={!isOpen ? item.title : ""}
                      onMouseEnter={(e) => {
                        if (!isActive && !hasActiveChild) {
                          e.currentTarget.style.color = "white";
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (!isActive && !hasActiveChild) {
                          e.currentTarget.style.color = "rgba(255,255,255,0.7)";
                        }
                      }}
                    >
                      <div
                        className={`d-flex align-items-center ${!isOpen ? "justify-content-center" : ""
                          }`}
                      >
                        <span
                          className={`${isOpen ? "me-3" : ""}`}
                          style={{
                            fontSize: "1.1rem",
                            color:
                              isActive || hasActiveChild
                                ? "white"
                                : "rgba(255,255,255,0.7)",
                          }}
                        >
                          {!isOpen && !idlbay ? (
                            <span
                              style={{ fontSize: "0.9rem", fontWeight: "bold" }}
                            >
                              {item.title.charAt(0)}
                            </span>
                          ) : (
                            <IconComponent />
                          )}
                        </span>
                        {isOpen && (
                          <span style={{ fontSize: "0.9rem" }}>{item.title}</span>
                        )}
                      </div>

                      {/* Show submenu indicator if hasSubmenu is true, has permitted children, and sidebar is open */}
                      {item.hasSubmenu && permittedChildren.length > 0 && isOpen && (
                        <span className="ms-auto">
                          <i
                            className={`fas fa-chevron-${isExpanded ? "down" : "right"
                              }`}
                            style={{
                              fontSize: "0.8rem",
                              color: "rgba(255,255,255,0.5)",
                            }}
                          ></i>
                        </span>
                      )}
                    </div>

                    {/* Submenu Items - Only show if there are permitted children */}
                    {permittedChildren.length > 0 && isOpen && isExpanded && (
                      <div className="mt-1">
                        {permittedChildren.map((child) => {
                          const ChildIconComponent = child.icon;
                          const isChildActive = currentActiveItem === child.id;

                          return (
                            <Link
                              key={child.id}
                              to={child.path}
                              className={`btn text-start w-100 d-flex align-items-center py-2 px-3 rounded text-decoration-none mb-1`}
                              onClick={(e) => {
                                e.preventDefault();
                                handleChildClick(child, item);
                              }}
                              style={{
                                backgroundColor: "transparent",
                                border: "none",
                                color: isChildActive
                                  ? "white"
                                  : "rgba(255,255,255,0.6)",
                                fontWeight: isChildActive ? "600" : "400",
                                marginLeft: "20px",
                                fontSize: "0.85rem",
                                transition: "all 0.2s ease",
                              }}
                              onMouseEnter={(e) => {
                                if (!isChildActive) {
                                  e.currentTarget.style.color = "white";
                                }
                              }}
                              onMouseLeave={(e) => {
                                if (!isChildActive) {
                                  e.currentTarget.style.color =
                                    "rgba(255,255,255,0.6)";
                                }
                              }}
                            >
                              <span
                                className="me-2"
                                style={{ fontSize: "0.85rem" }}
                              >
                                <ChildIconComponent />
                              </span>
                              <span>{child.title}</span>
                            </Link>
                          );
                        })}
                      </div>
                    )}
                  </div>
                );
              })}
          </nav>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
